<template>
<div class="chapter">
<div class="inner_page">
<p class="sp-brk2"> </p>
<p class="fmh">CONTENTS</p>
<p class="toc"><span href="#/xhtml/002_titlehead#head-title" title="Link target outside of Sample">Title Page</span></p>
<p class="toc-bot"><span href="#/xhtml/002_dedication#ded" title="Link target outside of Sample">Dedication</span></p>
<p class="toc-bot"><a href="#/xhtml/002_beginreading#beread">Begin Reading</a></p>
<p class="toc"><span href="#/xhtml/002_adcard#adc" title="Link target outside of Sample">Also by Walter Mosley</span></p>
<p class="toc"><span href="#/xhtml/002_atauthor#ata" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/xhtml/002_copyright#crp" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002_contents.vue?eeabb1a2